export default "__VITE_ASSET__CuCaeos8__"